import {Component, OnInit} from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";

@Component({
    selector: 'app-datesheet',
    templateUrl: './datesheet.component.html',
    styleUrls: ['./datesheet.component.scss']
})
export class DatesheetComponent implements OnInit {

    constructor(
        private meta: Meta,
        private titles: Title
    ) {
    }

    ngOnInit(): void {
        window.scrollTo(0, 0);

        this.updateMetaTags();
    }

    updateMetaTags() {
        this.titles.setTitle('ARNI Datesheet: Access Your Exam Schedule');
        this.meta.updateTag({
            name: 'description',
            content: `View the ARNI Datesheet for detailed exam schedules, including dates, times, and venues. Stay organized and prepared for your upcoming assessments.`
        });
    }

}
